'use client';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { ExternalLink } from 'lucide-react';

interface AssociationTooltipProps {
  name: string;
  code: string;
  description: string | null;
  websiteUrl: string | null;
}

export function AssociationTooltip({
  name,
  code,
  description,
  websiteUrl,
}: AssociationTooltipProps) {
  const hasTooltipContent = description || websiteUrl;

  const trigger = (
    <span className="text-sm text-slate-700">{name}</span>
  );

  if (!hasTooltipContent) {
    return trigger;
  }

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" className="text-left cursor-default">
            <span className="text-sm text-slate-700 underline decoration-dotted underline-offset-2 decoration-slate-300">
              {name}
            </span>
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <div className="space-y-1.5 text-xs">
            {description && (
              <p className="text-slate-600">{description}</p>
            )}
            {websiteUrl && (
              <a
                href={websiteUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 hover:underline font-medium"
                onClick={(e) => e.stopPropagation()}
              >
                <ExternalLink className="w-3 h-3" />
                Visit website
              </a>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
